import axios from 'axios';
import { API_URL } from '../app/constants/APIKEYS';

export default class API {
  /**
   * API발송 메소드, /v1 + url
   */
  static async send(
    method: string,
    url: string,
    token: string | null,
    data: any,
    logout: boolean = true,
    apiurl?: string
  ) {
    try {
      const headers = this.getHeaders(token);
      const options = this.getOptions(method, headers, data);

      const res = await fetch(
        (apiurl ? apiurl : API_URL) + url,
        options as RequestInit
      )
        .then((res) => {
          return res.json();
        })
        .then((res) => {
          if (res.code === 503) {
            if (logout) this.forceLogout();
          }
          return res;
        });
      return res;
    } catch (e) {
      console.log(e);
      if (logout) this.forceLogout();
    }
  }

  static async get(
    url: string,
    token: string | null,
    data: any,
    logout: boolean = true,
    apiurl?: string
  ) {
    return this.send('GET', url, token, data, logout, apiurl);
  }

  static async postNoLogout(
    url: string,
    token: string | null,
    data: any,
    apiurl?: string
  ) {
    return this.send('POST', url, token, data, false, apiurl);
  }

  static async post(
    url: string,
    token: string | null,
    data: any,
    apiurl?: string
  ) {
    return this.send('POST', url, token, data, true, apiurl);
  }

  static async delete(
    url: string,
    token: string | null,
    data: any,
    apiurl?: string
  ) {
    return this.send('DELETE', url, token, data, true, apiurl);
  }

  static async put(
    url: string,
    token: string | null,
    data: any,
    apiurl?: string
  ) {
    return this.send('PUT', url, token, data, true, apiurl);
  }

  static async patch(
    url: string,
    token: string | null,
    data: any,
    apiurl?: string
  ) {
    return this.send('PATCH', url, token, data, true, apiurl);
  }

  static async getPublic(url: string) {
    return this.send('GET', url, null, {});
  }

  static async postPublic(url: string, data: any) {
    return this.send('POST', url, null, data);
  }

  static async deletePublic(url: string, data: any) {
    return this.send('DELETE', url, null, data);
  }

  static async putPublic(url: string, data: any) {
    return this.send('PUT', url, null, data);
  }

  static async refreshToken(token: string) {
    try {
      const options = this.getOptions('POST', this.getHeaders(token), {
        token,
      });

      const res = await fetch(API_URL + '/auth/refresh', options)
        .then((res) => {
          return res.json();
        })
        .then((res) => {
          if (res.code !== 0) {
            return false;
          }
          return res;
        });
      return res;
    } catch (e) {
      console.log(e);
      this.forceLogout();
    }
  }

  static getHeaders(token: string | null) {
    const headers: any = token
      ? {
          Authorization: 'Bearer ' + token,
          'Content-Type': 'application/json',
        }
      : {
          'Content-Type': 'application/json',
        };
    return headers;
  }

  static getOptions(method: string, headers: any, data?: any) {
    const options =
      method.toLocaleUpperCase() === 'GET'
        ? {
            method: method,
            headers: headers,
          }
        : {
            method: method,
            headers: headers,
            body: JSON.stringify(data),
          };
    return options;
  }

  static forceLogout() {
    window.location.href = '/logout';
  }
}

export const loadData = async (number?: any) => {
  try {
    const result = await axios.get('http://api.upbit.com/v1/market/all', {
      responseType: 'json', // Ensures JSON response
    });

    const newResult = number ? result?.data?.slice(0, number) : result?.data;
    return newResult?.filter((d: any) => d.market?.match(/^KRW+/));
  } catch (error: any) {
    console.error('Error fetching data:', error.message);
    return []; // Return an empty array or handle the error as needed
  }
};
